export default {
  documentVisibilityState: 'visible',
  connectionState: 'ready',
  leaved: false,
  leaveReason: null,
  isModalDeviceSetting: false, // 장치 설정
  showParticipationRate: false, // 참여도
  tabMode: 'home', // 현재 선택된 탭 모드
  oneLineMixerLayoutCount: 11,
  testLayoutList: ['clone_mode_04_04'],
  isShowSideWrap: true,
  readyToSchedule: true,
  readyToScheduleTime: null,
  lowPowerMode: 'none',

  devices: {
    videoinput: [],
    audioinput: [],
    audiooutput: [],
  },
  deviceSettings: {
    init: false,
    audio: {
      deviceId: null,
      useNoiseCancel: true,
    },
    video: {
      deviceId: null,
      usePreviewMirror: true,
    },
    audiooutput: {
      deviceId: null
    }
  },
  noiseCancelAvailable: false,

  scheduleType: null,
  isVideoShare: false,
  rightSide: {
    contentsParti: {
      sortType: String,
      sortTx: '정렬',
      sortModal: false,
      authModal: false
    }
  },
  isFullScreen: false,

  //////////////////////////

  roomDataInitComplete: false,
  room: {},
  roomLms: {},
  roomCall: {
    callType: 'p2p',
    isEmptyLayoutType: '',
    videoLayout: '',
    mixingLayoutData: {}
  },
  roomDoc: {},
  roomMedia: {},
  roomShareNote: {
    noteId: null
  },
  roomUserList: [],
  roomUserObj: {},
  roomGroupList: [],
  roomQuestionList: [],
  roomGoalList: [],
  roomScheduleList: [],
  roomInfo: {},
  me: {},
  
  
  ///////////////////////////// videoLayout

  normalLayoutList:[
    'ml_01_00',
    'ml_02_00',
    'ml_02_01',
    'ml_03_00',
    'ml_03_01',
    'ml_04_00',
    'ml_04_01',
    'ml_05_00',
    'ml_05_01',
    'ml_06_00',
    'ml_07_00',
    'ml_08_00',
    'ml_09_00',
    'ml_10_00',
    'ml_10_01',
    'ml_11_00',
    'ml_11_01',
    'ml_vad_11_00',
    'ml_vad_11_01',
    'ml_12_00',
    'ml_12_01',
    'ml_13_00',
    'ml_14_00',
    'ml_15_00',
    'ml_16_00',
    'ml_17_00',
    'ml_19_00',
    'ml_20_00',
    'ml_21_00',
    'ml_vad_21_00',
    'ml_vad_21_01',
    'ml_22_00',
    'ml_22_01',
    'ml_25_00',
    'ml_30_00',
    'ml_31_00',
    'ml_31_01',
    'ml_32_00',
    'ml_32_01',
    'ml_33_00',
    'ml_36_00',
    'ml_40_00',
    'ml_41_00',
    'ml_41_01',
    'ml_42_00',
    'ml_42_01',
    'ml_43_00',
    'ml_46_00',
    'ml_49_00',
    'ml_49_01',
    'ml_56_00',
    'ml_58_00',
    'ml_61_00',
    'ml_64_00',
    'ml_81_00',
    'ml_100_00',
  ],
  presentationLayoutList:[
    'ml_rg_main_empty_01_00',
    'ml_rg_group_area_film_01_00',
    'ml_rg_group_area_film_02_00',
    'ml_rg_group_area_film_03_00',
    'ml_rg_group_area_film_04_00',
    'ml_rg_group_area_film_05_00',
    'ml_rg_group_area_film_06_00',
    'ml_rg_group_area_film_07_00',
    'ml_rg_group_area_film_08_00',
    'ml_rg_group_area_film_09_00',
    'ml_rg_group_area_film_10_00',
    'ml_rg_group_area_01_00',
    'ml_rg_group_area_02_00',
    'ml_rg_group_area_03_00',
    'ml_rg_group_area_03_01',
    'ml_rg_group_area_04_00',
    'ml_rg_group_area_04_01',
    'ml_rg_group_area_04_01',
  ],
  cloneModeLayoutTypeList: [
    'clone_mode_11_22_01',
    'clone_mode_11_22_02',
    'clone_mode_11_22_04',
    'clone_mode_11_22_05',
    'clone_mode_11_22_06',
    'clone_mode_11_22_08',
  ],
  cloneModeLeLayoutTypeList: [
    'clone_mode_empty_11_22_01',
    'clone_mode_le_11_22_02',
    'clone_mode_le_11_22_05',
    'clone_mode_le_11_22_07',
  ],
  camStudyType: ['camstudy', 'cam_study', 'camstudy_m']
}
